import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { Field } from 'redux-form';
import InputGroup from '../InputGroup';
import InputGroupCustom from '../InputGroupCustom';
import TextareaGroup from '../TextareaGroup';
import DropDownSelect from '../DropDownSelect';

import { validateStep1 } from './validations';
import { requiredFormElements } from './representatives';

import Button from '../../components/Button';
import TwoGroup from '../../components/TwoGroup';
import { LocalRepState } from '../../utils/enums';
import { copyFor, capitalization } from '../../copy/copy';
import { findTopicByActionIdentifier } from '../../utils/formCaching/helpers';

import defaultImage from '../../assets/images/localRepDefault.jpg';

const DetailsFormContainer = styled.form`
    flex: 1;
    padding: 0;
    display: flex;
    flex-direction: column;
`;

const Row = styled.div`
    margin: 0 -0.5em 12px -0.5em;
    transition: opacity 0.6s;

    @media (max-width: 30em) {
        ${props => (props.senatorsNotAvailable ? 'margin-top: -12px;' : '')};
    }

    .label-response {
        @media (min-width: 30em) {
            position: absolute;
            width: 100%;
            transition: bottom 0.6s;
            bottom: 142px;
            ${props => (props.senatorsNotAvailable ? 'bottom: 202px !important;' : '')};
        }
    }

    textarea {
        ${props => (props.senatorsNotAvailable ? 'height: 130px !important;' : '')};

        @media (max-width: 30em) {
            ${props => (props.senatorsNotAvailable ? 'height: 300px !important;' : '')};
        }
    }

    &.row-wrapper-3 {
        position: absolute;
        bottom: -15px;
        left: 0;
        width: 100%;

        @media (max-width: 30em) {
            position: static;
            width: auto;

            textarea {
                height: 175px;
            }
        }
    }

    &.focused {
        opacity: 0;

        &.row-wrapper-3 {
            opacity: 1;

            .label-response {
                bottom: 274px !important;
            }

            textarea {
                height: 200px !important;
            }
        }
    }
`;

const FullRow = styled.div`
    width: 100%;
    padding: 0 8px;
    position: relative;
`;

const ButtonGroup = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    position: absolute;
    right: 0;
    bottom: 10px;
    width: 70%;

    @media (max-width: 30em) {
        width: 100%;
    }

    > div {
        position: relative;
    }

    button {
        &.submitButton {
            margin-left: 0.5em;

            @media (max-width: 30em) {
                width: calc(50% - 0.5em);
            }
        }

        &.middleButton {
            @media (max-width: 30em) {
                width: calc(50% - 0.5em);
                margin-right: 0.5em;
            }
        }

        &:focus {
            outline: none;
        }
    }
`;

const getActiveTopic = (options, issue, subIssue) => {
    const issueTopics = issue && issue.senatorTopics ? issue.senatorTopics : [];
    const subIssueTopics =
        subIssue && subIssue.senatorTopics ? subIssue.senatorTopics : [];
    const matchedSubIssueTopics = subIssueTopics.filter(si => options.indexOf(si) > -1);
    if (matchedSubIssueTopics.length > 0) return matchedSubIssueTopics[0];
    const matchedIssueTopics = issueTopics.filter(si => options.indexOf(si) > -1);
    if (matchedIssueTopics.length > 0) return matchedIssueTopics[0];
    return options.find(o => o === 'Other') || null;
};

const DetailsFormMultiRepStep1 = props => (
    <DetailsFormContainer onSubmit={props.handleSubmit} autocomplete="on">
        <Row className="row-wrapper-1">
            <FullRow>
                <Field
                    name="recipient"
                    component={InputGroupCustom}
                    onDeleteClick={props.onDeleteClick}
                    onAddClick={props.onAddClick}
                    onShowRepresentatives={props.onShowRepresentatives}
                    type="text"
                    label="To"
                    placeholder="Add Receipients"
                    representatives={props.representatives}
                    hiddenRepresentatives={props.hiddenRepresentatives}
                    representativesVisibility={props.representativesVisibility}
                />
            </FullRow>
        </Row>
        <Row className="row-wrapper-2">
            {props.requiredFormElements
                .filter(function(a) {
                    return a.name === 'Topic';
                })
                .map(a => (
                    <FullRow key={a.index}>
                        <Field
                            name="topic"
                            component={a.options.length > 0 ? DropDownSelect : InputGroup}
                            options={a.options}
                            defaultOption={props.initialValues.topic || a.defaultOption}
                            type="text"
                            label="Subject"
                            placeholder={a.placeholder}
                        />
                    </FullRow>
                ))}
        </Row>
        <Row className="row-wrapper-3" senatorsNotAvailable={props.senatorsNotAvailable}>
            <FullRow>
                <Field
                    title="message"
                    name="message"
                    component={TextareaGroup}
                    label="MESSAGE TEXT"
                    placeholder="Add your message"
                    class="message-response"
                    classLabel="label-response"
                />
            </FullRow>
        </Row>
        <ButtonGroup>
            <TwoGroup>
                <Button
                    label={copyFor('buttons', 'back', 'email', capitalization.eachWord)}
                    onClick={props.onBackFromRepAction}
                    className="middleButton"
                />
                <Button
                    primary={true}
                    label={copyFor(
                        'buttons',
                        'continue',
                        'email',
                        capitalization.eachWord
                    )}
                    type="submit"
                    className="submitButton"
                    disabled={props.invalid}
                />
            </TwoGroup>
        </ButtonGroup>
    </DetailsFormContainer>
);

DetailsFormMultiRepStep1.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    requiredFormElements: PropTypes.array.isRequired,
    representatives: PropTypes.array.isRequired,
    hiddenRepresentatives: PropTypes.array.isRequired,
    initialValues: PropTypes.object.isRequired,
    onDeleteClick: PropTypes.func.isRequired,
    onAddClick: PropTypes.func.isRequired,
    onShowRepresentatives: PropTypes.func.isRequired,
    senatorsNotAvailable: PropTypes.bool,
    representativesVisibility: PropTypes.bool,
    onBackFromRepAction: PropTypes.func
};

export default compose(
    connect(state => {
        const formElements = requiredFormElements(state);
        return {
            actionIdentifier: state.widget.activeAction.identifier,
            requiredFormElements: formElements,
            initialValues: {
                getUpdates: true,
                topic:
                    state.cachedFormData.topic.length > 0
                        ? findTopicByActionIdentifier(
                              state.cachedFormData.topic,
                              state.widget.activeAction.identifier
                          )
                        : formElements
                              .filter(a => a.name === 'Topic')
                              .map(a =>
                                  getActiveTopic(
                                      a.options,
                                      state.widget.activeAction.issue,
                                      state.widget.activeAction.subIssue
                                  )
                              )[0],
                message: state.widget.activeAction.text.replace(
                    /@localRepresentative/g,
                    state.localRep.localRepData.representative !== undefined
                        ? state.localRep.localRepData.representative.length < 2
                            ? state.localRep.localRepData.representative[0].fullName
                            : state.widget.activeAction.localRepresentativeState ===
                              LocalRepState.senators
                            ? state.localRep.localRepData.representative.length > 2
                                ? state.localRep.localRepData.representative[2].fullName +
                                  ' and ' +
                                  state.localRep.localRepData.representative[1].fullName
                                : state.localRep.localRepData.representative[1].fullName
                            : state.localRep.localRepData.representative.length > 2
                            ? state.localRep.localRepData.representative[2].fullName +
                              ', ' +
                              state.localRep.localRepData.representative[1].fullName +
                              ' and ' +
                              state.localRep.localRepData.representative[0].fullName
                            : state.localRep.localRepData.representative[1].fullName +
                              ' and ' +
                              state.localRep.localRepData.representative[0].fullName
                        : ''
                )
            },
            representatives: state.localRep.localRepData.representative
                ? state.localRep.localRepData.representative
                      .filter(function(a) {
                          return state.widget.activeAction.localRepresentativeState ===
                              LocalRepState.senators
                              ? a.level === 2 &&
                                    a.canBeEmailed &&
                                    (a.fullName !==
                                        state.localRep.hiddenRepresentatives[0] &&
                                        a.fullName !==
                                            state.localRep.hiddenRepresentatives[1])
                              : (a.level === 2 || a.level === 1) &&
                                    a.canBeEmailed &&
                                    (a.fullName !==
                                        state.localRep.hiddenRepresentatives[0] &&
                                        a.fullName !==
                                            state.localRep.hiddenRepresentatives[1] &&
                                        a.fullName !==
                                            state.localRep.hiddenRepresentatives[2]);
                      })
                      .map((a, index) => ({
                          shortName: a.shortName,
                          fullName: a.fullName,
                          photoUrl: a.photoUrl || defaultImage,
                          index: index
                      }))
                      .reverse()
                : [],
            hiddenRepresentatives: state.localRep.localRepData.representative
                ? state.localRep.localRepData.representative
                      .filter(function(a) {
                          return state.widget.activeAction.localRepresentativeState ===
                              LocalRepState.senators
                              ? a.level === 2 &&
                                    a.canBeEmailed &&
                                    (a.fullName ===
                                        state.localRep.hiddenRepresentatives[0] ||
                                        a.fullName ===
                                            state.localRep.hiddenRepresentatives[1])
                              : (a.level === 2 || a.level === 1) &&
                                    a.canBeEmailed &&
                                    (a.fullName ===
                                        state.localRep.hiddenRepresentatives[0] ||
                                        a.fullName ===
                                            state.localRep.hiddenRepresentatives[1] ||
                                        a.fullName ===
                                            state.localRep.hiddenRepresentatives[2]);
                      })
                      .map((a, index) => ({
                          fullName: a.fullName,
                          photoUrl: a.photoUrl || defaultImage,
                          index: index
                      }))
                      .reverse()
                : [],
            representativesVisibility: state.localRep.representativesVisibility,
            senatorsNotAvailable:
                state.localRep.localRepData.representative !== undefined
                    ? state.localRep.localRepData.representative.length < 2
                    : false
        };
    }),
    reduxForm({
        form: 'emailDetailsFormMultiRepStep1',
        validate: validateStep1,
        destroyOnUnmount: true
    })
)(DetailsFormMultiRepStep1);



// WEBPACK FOOTER //
// ./src/components/Email/DetailsFormMultiRepStep1.jsx